import logoBrand from '@/assets/images/logo_basciano.svg'
import { DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog'
import { Logo } from '@/components/molecules/Logo/Logo'
import { LanguageSelector } from '@/components/molecules/LanguageSelector/LanguageSelector'

interface ModalHeaderProps {
  title: string
  date: string
  className?: string
  onClose?: () => void
}

export function ModalHeader({ title, date, className = "" }: ModalHeaderProps) {
  return (
    <DialogHeader className={`px-8 py-6 border-b border-slate-200 bg-white rounded-t-lg shadow-sm ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-8">
          <div className="flex-shrink-0">
            <div className="w-32 h-12 flex items-center">
              <Logo src={logoBrand} alt='Basciano Trading Corporation' width={128} height={48} />
            </div>
          </div>
          <div className="flex flex-col">
            <DialogTitle className="text-2xl font-bold text-slate-900 leading-tight tracking-tight">{title}</DialogTitle>
            <DialogDescription className="text-sm text-slate-500 mt-1 font-medium">{date}</DialogDescription>
          </div>
        </div>
        <div className="flex items-center pr-4">
          <LanguageSelector className="text-slate-600 hover:text-slate-800 transition-colors" />
        </div>
      </div>
    </DialogHeader>
  )
}
